import React, { useState, useEffect, useRef } from 'react';
import './CardItem.css';
import { FaLock, FaPlay } from 'react-icons/fa';
import { ContentStatus } from '../../Models/ContentStatus';

const MAX_RETRIES = 3;
const RETRY_DELAY = 2000;

const CardItem = ({ status = ContentStatus.AVAILABLE, imageUrl }) => {
  const [loadedImage, setLoadedImage] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  const loadImage = (url, retry = 0) => {
    if (retry >= MAX_RETRIES) return;

    const img = new Image();

    img.onload = () => {
      setLoadedImage(url);
    };

    img.onerror = () => {
      setTimeout(() => {
        loadImage(url, retry + 1);
      }, RETRY_DELAY);
    };

    img.src = url;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When the component becomes visible
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      {
        root: null, // viewport
        rootMargin: '50px', // Start loading slightly before it comes into view
        threshold: 0.1 // Trigger when at least 10% is visible
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isVisible && imageUrl) {
      loadImage(imageUrl);
    }
  }, [isVisible, imageUrl]);

  return (
    <div
      ref={cardRef}
      className={`card-item-image-wrapper status-${status}`}
      style={{ backgroundImage: loadedImage ? `url(${loadedImage})` : 'none' }}
    >
      {(status === ContentStatus.BLOCKED || status === ContentStatus.ACTIVE) && (
        <div className="card-item-overlay">
          {status === ContentStatus.BLOCKED && (
            <>
              <FaLock className="card-item-icon" />
              <p className="card-item-text">Conteúdo bloqueado</p>
            </>
          )}
          {status === ContentStatus.ACTIVE && <FaPlay className="card-item-icon" />}
        </div>
      )}
    </div>
  );
};

export default CardItem;
